// ===========================================================================
// LOS CURSOS. Datos tomados uno por uno de zenkai.com.mx.
//
// Cada curso declara UNA categoría —su casa temática— y puede formar parte de
// varias certificaciones. Esa relación se lee desde certificaciones.js, no se
// duplica aquí: la certificación lista sus módulos y aquí vive la ficha.
//
// SOBRE LAS DURACIONES: son las de video que publica cada página de curso.
// Sumadas dan 24 h 1 min en 97 capítulos, mientras que la certificación Lean
// Leader declara 40 h. La diferencia es real y no se disimula: en las páginas
// se publica el minutaje verificable de cada curso, y las 40 h se citan como
// lo que son, la cifra oficial de la certificación.
//
// FORMATOS REPETIDOS: el sitio actual asigna los mismos tres formatos a varios
// cursos —"KPI Lean Daily Management / LDM Board / LDM Meetings" aparece en
// 5S, en Lean Daily Management y en Administrative Process Kaizen; "SW Layout /
// HOE / Takt Time Calculator" en Lean Thinking, Set Up Wheel, Flujo Continuo y
// VSM—. Se transcriben tal cual, pero salvo en LDM y en Flujo Continuo casi con
// seguridad son un copiar-pegar del sitio anterior. Pendiente de confirmar.
// ===========================================================================

export const CURSOS = [
  {
    slug: 'hoshin-kanri',
    cat: 'lean',
    nombre: 'Hoshin Kanri',
    titulo: 'Matriz X Hoshin Kanri',
    subtitulo: 'Planificación estratégica y despliegue de objetivos',
    duracion: '2 h 2 min',
    minutos: 122,
    descripcion: 'Aprende a diseñar y aplicar la Matriz X de Hoshin Kanri, una de las herramientas más efectivas de planificación estratégica y gestión por objetivos. Este curso te enseñará qué es Hoshin Kanri, su significado y cómo aplicarlo en la empresa, diferenciando entre un plan estratégico tradicional y un modelo Hoshin Kanri basado en el despliegue de políticas.',
    paraQuien: 'Directores, Gerentes, Líderes de Mejora Continua, Ingenieros de Procesos y Profesionales responsables de diseñar e implementar estrategias organizacionales. Ideal para quienes buscan alinear la visión empresarial con la ejecución operativa.',
    temas: [
      ['Conceptos y Definiciones', 2],
      ['Entender y Documentar una Matriz X', 4],
      ['Cascada', 1],
      ['Bowler y Plan de Acción', 3],
    ],
    formatos: ['Action Plan', 'Bowler', 'SDP Top Level'],
    instructor: 'Julio Pasos',
  },
  {
    slug: 'lean-thinking',
    cat: 'lean',
    nombre: 'Lean Thinking',
    titulo: 'Lean Thinking',
    subtitulo: 'Fundamentos del pensamiento Lean',
    duracion: '1 h 40 min',
    minutos: 100,
    descripcion: 'Descubre qué es Lean Thinking y cómo puede transformar tu organización a través de la eliminación de desperdicios y la creación de valor sostenible. En este curso aprenderás los 5 principios del Lean Thinking, aplicados de manera práctica para optimizar procesos, reducir costos y aumentar la rentabilidad.',
    paraQuien: 'Supervisores, Líderes de Equipo, Ingenieros de Procesos, Analistas de Operaciones y Profesionales que buscan implementar metodologías Lean.',
    temas: [
      ['¿Por qué Implementar Lean?', 4],
      ['Lean Como Perspectiva de Negocio', 1],
      ['Los Desperdicios de Lean y Herramientas Claves', 1],
      ['Liderando la transformación de Lean Enterprise', 2],
    ],
    formatos: ['SW Layout', 'HOE', 'Takt Time Calculator'],
    instructor: 'Julio Pasos',
  },
  {
    slug: 'value-stream-mapping',
    cat: 'lean',
    nombre: 'Value Stream Mapping',
    titulo: 'VSM Value Stream Mapping',
    subtitulo: 'Mapeo de la cadena de valor',
    duracion: '2 h 30 min',
    minutos: 150,
    descripcion: 'Descubre cómo VSM puede transformar la gestión de tus procesos. Este curso te enseñará a diseñar y analizar mapas de flujo de valor desde los conceptos básicos hasta la creación de mapas de estado actual y futuro, permitiéndote visualizar de manera clara cada etapa de la cadena de valor. Aprenderás a identificar cuellos de botella, desperdicios y oportunidades de mejora en tus operaciones.',
    paraQuien: 'Supervisores, Ingenieros de Procesos, Líderes de Mejora Continua y Profesionales interesados en aplicar Value Stream Mapping (VSM).',
    temas: [
      ['Introducción de Value Stream Mapping', 2],
      ['Mapa de estado actual', 3],
      ['Creando una cadena de valor Lean', 2],
      ['Mapa de estado futuro', 2],
    ],
    formatos: ['SW Layout', 'HOE', 'Takt Time Calculator'],
    instructor: 'Julio Pasos',
  },
  {
    slug: 'lean-daily-management',
    cat: 'lean',
    nombre: 'Lean Daily Management',
    titulo: 'Lean Daily Management',
    subtitulo: 'Gestión diaria para líderes Lean',
    duracion: '2 h 10 min',
    minutos: 130,
    descripcion: 'Aprende a implementar el Lean Daily Management (LDM) como un sistema práctico para alinear las operaciones diarias con los objetivos estratégicos de tu empresa. Este curso te enseñará a utilizar tableros de control visual, reuniones diarias y métricas clave para mejorar la eficiencia operativa, la toma de decisiones y la cultura de mejora continua.',
    paraQuien: 'Directores, Gerentes, Supervisores, Ingenieros de Proyectos, Superintendentes y Líderes organizacionales responsables de gestionar equipos y optimizar el rendimiento del personal.',
    temas: [
      ['Conceptos básicos de LDM', 2],
      ['Pizarrón KPI', 4],
      ['Hora x Hora', 1],
      ['Trabajo Estándar de Líder', 2],
      ['Conductas de Liderazgo', 1],
    ],
    formatos: ['KPI Lean Daily Management', 'Lean Daily Management Board', 'Lean Daily Management Meetings'],
    instructor: 'Julio Pasos',
  },
  {
    slug: 'set-up-wheel',
    cat: 'lean',
    nombre: 'Set Up Wheel',
    titulo: 'Set Up Wheel',
    subtitulo: 'Estandarización de cambios rápidos',
    duracion: '31 min',
    minutos: 31,
    descripcion: 'Domina la metodología Set Up Wheel para optimizar los tiempos de preparación y reducir el tiempo muerto en los cambios de producción. Este curso te enseñará a secuenciar operaciones de manera estratégica, mejorar la eficiencia en planta y maximizar el uso de recursos en tus procesos.',
    paraQuien: 'Facilitadores, entrenadores, ingenieros de procesos, supervisores, líderes de mejora continua, gerentes de soporte y profesionales de operaciones interesados en optimizar la programación de la producción.',
    temas: [
      ['Significado y Metodología de un SUW', 1],
      ['Aplicación y Ejercicio Final', 1],
    ],
    formatos: ['SW Layout', 'HOE', 'Takt Time Calculator'],
    instructor: 'Julio Pasos',
  },
  {
    slug: 'quality-inspection-kaizen',
    cat: 'lean',
    nombre: 'Quality Inspection Kaizen',
    titulo: 'Quality Inspection Kaizen',
    subtitulo: 'Mejora en procesos de calidad',
    duracion: '1 h 55 min',
    minutos: 115,
    descripcion: 'Descubre cómo aplicar Quality Inspection Kaizen para elevar la calidad y confiabilidad de tus procesos de inspección. Este curso te enseñará a implementar estrategias de mejora continua que permiten detectar errores de manera temprana, reducir desperdicios y optimizar la eficiencia operativa.',
    paraQuien: 'Supervisores de Calidad, Ingenieros de Procesos, Auditores Internos, Líderes de Producción y Profesionales responsables de implementar sistemas de inspección de calidad.',
    temas: [
      ['Introducción', 1],
      ['Pre-trabajo y Mapeo de Proceso', 1],
      ['Matriz Detallada de Inspección', 1],
      ['Matriz de Evaluación de Riesgo', 1],
      ['Plan de Mejora y Racional', 1],
      ['Simulación', 2],
    ],
    formatos: ['As is will be', 'Kaizen Pre-work'],
    instructor: 'Julio Pasos',
  },
  {
    slug: 'pull-system',
    cat: 'lean',
    nombre: 'Pull System',
    titulo: 'Pull System',
    subtitulo: 'Implementación del sistema de jalón Lean',
    duracion: '1 h 50 min',
    minutos: 110,
    descripcion: 'Aprende qué es el Pull System y cómo aplicarlo para optimizar la producción, reducir inventarios innecesarios y alinear la demanda real con el suministro. Este curso te enseñará a implementar el Pull System Lean como parte fundamental del Lean Manufacturing, utilizando ejemplos claros, diagramas prácticos y herramientas aplicables en cualquier industria.',
    paraQuien: 'Supervisores, Gerentes de Producción, Ingenieros de Procesos, Líderes de Mejora Continua y Profesionales que buscan implementar metodologías Lean.',
    // El sitio solo publica cuatro de los nueve capítulos. Se listan los que
    // hay; los cinco restantes no se inventan.
    temas: [
      ['Conceptos básicos de Pull System', 2],
      ['Pasos para implementar Pull System', 2],
    ],
    temasIncompletos: true,
    capitulos: 9,
    formatos: ['PFEP', 'A Card', 'B Card'],
    instructor: 'Julio Pasos',
  },
  {
    slug: 'lider-de-evento-kaizen',
    cat: 'lean',
    nombre: 'Líder de Evento Kaizen',
    titulo: 'Líder de Evento Kaizen',
    subtitulo: 'Cómo guiar un kaizen exitoso',
    duracion: '2 h 31 min',
    minutos: 151,
    descripcion: 'Conviértete en Líder de Evento Kaizen y adquiere las habilidades necesarias para planear, organizar y ejecutar eventos Kaizen efectivos dentro de tu empresa. Este curso te enseñará qué es un evento Kaizen, sus pasos principales y su propósito dentro de la filosofía Lean, aplicándolo en procesos operativos y administrativos.',
    paraQuien: 'Supervisores, Gerentes, Ingenieros de Procesos, Líderes de Mejora Continua y Profesionales de manufactura y servicios que buscan implementar eventos Kaizen como herramienta de mejora continua.',
    temas: [
      ['Introducción al Evento Kaizen', 1],
      ['Pre-Trabajo', 1],
      ['Ejecución de Evento Kaizen', 3],
      ['Roles y Responsabilidades', 1],
      ['Implementación', 2],
      ['Simulación de Evento Kaizen', 1],
    ],
    formatos: ['Kaizen Sustaining Tracking', 'Project Charter', 'Agenda Kaizen'],
    instructor: 'Julio Pasos',
  },
  {
    slug: '5s',
    cat: 'lean',
    nombre: '5S',
    titulo: 'Metodología 5S',
    subtitulo: 'Orden y disciplina en el entorno de trabajo',
    duracion: '1 h 32 min',
    minutos: 92,
    descripcion: 'Aprende qué son las 5S y cómo aplicar esta metodología para organizar y optimizar espacios de trabajo de forma eficiente. Comprenderás sus principios fundamentales —Seiri, Seiton, Seiso, Seiketsu y Shitsuke— y cómo implementarlos para lograr mayor orden y limpieza, reducir desperdicios y errores operativos, y mejorar la productividad y la seguridad.',
    paraQuien: 'Supervisores, Gerentes, Líderes de Equipo, Ingenieros de Procesos y Profesionales que buscan mejorar la organización, limpieza, eficiencia y calidad en sus espacios de trabajo.',
    temas: [
      ['Introducción a la metodología 5S', 1],
      ['Definición: qué son las 5S y para qué sirven', 1],
      ['Seiri · Clasificar', 1],
      ['Seiton · Organizar', 1],
      ['Seiso · Limpiar', 1],
      ['Seiketsu · Estandarizar', 1],
      ['Shitsuke · Sostener', 1],
      ['Ejercicio final: las 5S en tu lugar de trabajo', 1],
    ],
    formatos: ['KPI Lean Daily Management', 'Lean Daily Management Board', 'Lean Daily Management Meetings'],
    instructor: 'Julio Pasos',
  },
  {
    slug: 'smed',
    cat: 'lean',
    nombre: 'SMED',
    titulo: 'SMED · Single Minute Exchange of Die',
    subtitulo: 'Reducción de tiempos de cambio rápido',
    duracion: '1 h 51 min',
    minutos: 111,
    descripcion: 'Aprende a implementar la metodología SMED para reducir los tiempos de cambio de máquina y lograr una producción más ágil y flexible. Este curso te dará herramientas prácticas para estandarizar procesos de cambio rápido de utillaje, minimizar actividades internas y agilizar las transiciones entre productos sin afectar la calidad.',
    paraQuien: 'Supervisores de Producción, Ingenieros de Procesos, Líderes de Mejora Continua, Coordinadores de Mantenimiento y Operadores de planta que buscan optimizar cambios rápidos en líneas de producción.',
    temas: [
      ['Definición y Concepto', 1],
      ['¿Por qué reducir los cambios de modelo?', 1],
      ['6 Pasos de Implementación', 3],
      ['Ejercicio de Simulación', 1],
    ],
    formatos: ['CO Tracking Sheet', 'Change Over', 'Análisis de Operaciones'],
    instructor: 'Julio Pasos',
  },
  {
    slug: 'flujo-continuo',
    cat: 'lean',
    nombre: 'Continuous Flow',
    titulo: 'Flujo Continuo',
    subtitulo: 'Diseño de celdas de manufactura',
    duracion: '3 h 41 min',
    minutos: 221,
    descripcion: 'Aprende a implementar la producción de flujo continuo en tus procesos de manufactura mediante el diseño de celdas. Este curso te mostrará cómo aplicar un sistema de producción de flujo continuo para reducir desperdicios, mejorar la eficiencia operativa y aumentar la productividad en tu empresa.',
    paraQuien: 'Supervisores, Gerentes de Producción, Ingenieros de Procesos, Líderes de Mejora Continua y Profesionales de manufactura que buscan implementar un sistema de producción de flujo continuo en sus operaciones.',
    temas: [
      ['Introducción', 1],
      ['Conceptos Básicos', 1],
      ['Paso 1 · Estudio Actual', 1],
      ['Medición de Tiempo Takt', 1],
      ['Análisis de diagramas Spaghetti', 1],
      ['Observación de Tiempos', 1],
      ['Capacidad de Máquina', 1],
      ['Paso 2 · Análisis de Gaps', 1],
      ['Paso 3 · Guía para Diseño de Celda', 1],
      ['Paso 4 · Formato de Layout y Paso 5 · Beta Test', 1],
      ['Paso 6 · Sostenimiento', 1],
      ['Paso 7 · Playbooks', 1],
    ],
    formatos: ['SW Layout', 'HOE', 'Takt Time Calculator'],
    instructor: 'Julio Pasos',
  },
  {
    slug: 'administrative-process-kaizen',
    cat: 'lean',
    nombre: 'Administrative Process Kaizen',
    titulo: 'Administrative Process Kaizen',
    subtitulo: 'Kaizen en procesos administrativos',
    duracion: '1 h 48 min',
    minutos: 108,
    descripcion: 'Facilita eventos Kaizen y analiza procesos administrativos a través del diseño de mapas de procesos actuales y futuros, identificando con claridad las acciones estratégicas necesarias para su implementación.',
    paraQuien: 'Líderes de Equipo, Gerentes, Supervisores, Analistas y Profesionales que buscan optimizar procesos administrativos mediante la implementación de eventos Kaizen y el diseño estratégico de mapas de procesos.',
    temas: [
      ['Introducción', 1],
      ['Mapa de Proceso', 2],
      ['Entendiendo las Oportunidades', 1],
      ['Ideas de Mejora', 1],
      ['Documentando el Nuevo Proceso', 1],
      ['Simulación y Ejercicio Final', 1],
    ],
    formatos: ['KPI Lean Daily Management', 'Lean Daily Management Board', 'Lean Daily Management Meetings'],
    instructor: 'Julio Pasos',
  },
// ---- Six Sigma ---------------------------------------------------------
  // `alias`: el mismo curso aparece con nombres distintos según la
  // certificación que lo cite. El alias permite que ambas enlacen al mismo
  // curso en vez de dejar uno de los dos módulos sin destino.
  {
    slug: 'agenda-e-introduccion',
    cat: 'six',
    nombre: 'Agenda e Introducción al Curso',
    alias: ['Introducción'],
    titulo: 'Agenda e Introducción al Curso',
    subtitulo: 'Cómo se recorre la certificación',
    duracion: '10 min',
    minutos: 10,
    // El plan de estudios no publica una descripción por curso para los tres
    // primeros módulos de la Green Belt: esta se escribió a partir de su
    // temario y no afirma nada que el temario no diga.
    descripcion: 'El punto de partida de la Green Belt: el objetivo del programa, cómo está organizado el contenido y en qué orden se recorren los doce módulos.',
    descripcionPropia: true,
    paraQuien: 'Quien va a cursar la certificación Six Sigma Green Belt y quiere saber, antes de empezar, qué cubre y en qué orden.',
    temas: [
      ['Objetivo, contenido y agenda del curso', 1],
    ],
    formatos: [],
    instructor: 'Carlos Zamora',
  },
  {
    slug: 'introduccion-a-six-sigma-green-belt',
    cat: 'six',
    nombre: 'Introducción a Six Sigma Green Belt',
    titulo: 'Introducción a Six Sigma Green Belt',
    subtitulo: 'Qué resuelve la metodología y cuándo aplica',
    duracion: '55 min',
    minutos: 55,
    descripcion: 'Qué es Six Sigma, de dónde viene y para qué sirve: las condiciones de mercado que lo hicieron necesario —lead time, calidad y costo—, las premisas de los modelos determinísticos y probabilísticos, las 6 M y el ciclo DMAIC completo.',
    descripcionPropia: true,
    paraQuien: 'Ingenieros de procesos, calidad, diseño y manufactura, profesionales de operaciones, finanzas, recursos humanos y logística, gerentes, supervisores y en general todo personal involucrado en la mejora continua.',
    temas: [
      ['Condiciones de los mercados', 1],
      ['¿Qué es Six Sigma?', 1],
      ['Historia de Six Sigma', 1],
      ['Premisas Six Sigma', 1],
      ['¿Qué es DMAIC?', 1],
    ],
    formatos: [],
    instructor: 'Carlos Zamora',
  },
  {
    slug: 'definicion-de-problemas-y-situacion-actual',
    cat: 'six',
    nombre: 'Definición de Problemas y Situación Actual',
    titulo: 'Definición de Problemas y Situación Actual',
    subtitulo: 'El planteamiento que decide el proyecto',
    duracion: '41 min',
    minutos: 41,
    descripcion: 'El planteamiento del problema es lo que decide si el proyecto sirve. De la voz del cliente a los CTQ, la pirámide de resultado y el diagrama de Pareto en Minitab, incluido el Pareto de segundo nivel para bajar del síntoma a la causa.',
    descripcionPropia: true,
    paraQuien: 'Aspirantes a Six Sigma Green Belt, ingenieros de procesos y calidad, líderes de mejora continua y cualquiera que tenga que sustentar un proyecto ante dirección.',
    temas: [
      ['VOC: Voz del Cliente', 1],
      ['Estrategia o Pirámide de Resultado', 1],
      ['Diagrama de Pareto', 1],
    ],
    formatos: [],
    instructor: 'Carlos Zamora',
  },
  {
    slug: 'estadistica-descriptiva',
    cat: 'six',
    nombre: 'Estadística Descriptiva',
    titulo: 'Estadística Descriptiva',
    subtitulo: 'Describir un proceso antes de juzgarlo',
    duracion: '1 h 35 min',
    minutos: 95,
    descripcion: 'Domina los fundamentos de la estadística descriptiva y aprende qué es, cómo se aplica y cuáles son sus diferencias con la estadística inferencial. Aprenderás a recolectar, organizar y analizar datos de manera efectiva, utilizando medidas clave como media, mediana, moda, varianza y desviacion estándar.',
    paraQuien: 'Aspirantes a Six Sigma Green Belt, profesionales de mejora continua, ingenieros de calidad, analistas de datos y toda persona interesada en comprender qué es la estadística descriptiva.',
    temas: [
      ['Fundamentos de Estadística Descriptiva', 1],
      ['Tipos de Datos y su Importancia', 1],
      ['Histogramas, Frecuencias y Funciones', 1],
      ['Propiedades y Medidas de Localización', 1],
      ['Variabilidad: Rango, Varianza y Desviación Estándar', 1],
      ['Estadísticos Descriptivos y Límites de Datos', 1],
    ],
    formatos: ['Ejercicio Desviación Estándar', 'Ejercicio Media, Mediana, Moda, Varianza', 'Ejercicio Análisis de Tendencia'],
    instructor: 'Carlos Zamora',
  },
  {
    slug: 'distribucion-de-la-probabilidad',
    cat: 'six',
    nombre: 'Distribución de la Probabilidad',
    titulo: 'Distribución de la Probabilidad',
    subtitulo: 'Normal, binomial y Poisson',
    duracion: '3 h 18 min',
    minutos: 198,
    descripcion: 'Domina los fundamentos de la distribución de la probabilidad y su aplicación en la toma de decisiones y el análisis de procesos.',
    paraQuien: 'Aspirantes a Six Sigma Green Belt, Profesionales de Control de Calidad, Ingenieros de Procesos y Analistas de Datos.',
    temas: [
      ['Introducción y Tipos de Distribuciónes', 1],
      ['Distribución Normal y Prueba de Normalidad', 1],
      ['Probabilidad de Falla y Representación Gráfica', 1],
      ['Capacidad del Proceso y Z Bench', 1],
      ['Datos No Normales y Capability Sixpack', 1],
      ['Distribuciónes Discretas: Binomial y Poisson', 1],
      ['Análisis Binomial y Probabilidad Bruta', 1],
      ['Probabilidad Acumulada y Modelos PAM', 1],
      ['Defectos y Distribución de Poisson en Procesos', 1],
      ['Ejemplos Avanzados de Distribución de Poisson', 1],
    ],
    formatos: ['Ejercicio Cálculo de Probabilidad', 'Ejercicio Teorema del Límite Central', 'Ejercicio CP y CPK'],
    instructor: 'Carlos Zamora',
  },
  {
    slug: 'msa',
    cat: 'six',
    nombre: 'Análisis del Sistema de Medición (MSA)',
    alias: ['Análisis de los Sistemas de Medición'],
    titulo: 'Análisis del Sistema de Medición (MSA)',
    subtitulo: 'Confiar en el dato antes de decidir',
    duracion: '1 h 46 min',
    minutos: 106,
    descripcion: 'Descubre qué son los sistemas de medición y cómo garantizar la precisión de tus resultados con el análisis de sistemas de medición (MSA). Aprenderás a evaluar y mejorar la confiabilidad de los datos aplicando herramientas como Gage R&R, ANOVA y estudios de repetibilidad y reproducibilidad.',
    paraQuien: 'Ingenieros de Calidad, Analistas de Datos, Supervisores de Producción, Líderes de Mejora Continua y aspirantes a Six Sigma Green Belt.',
    temas: [
      ['Introducción al MSA y a los sistemas de medición', 1],
      ['Distribución del Proceso y Gage R&R', 1],
      ['Planificación del Estudio Gage R&R', 1],
      ['Gage R&R: Ejemplo y Criterios de Evaluación', 1],
      ['Efectos y Estudio del R&R en Minitab', 1],
    ],
    formatos: ['Ejercicio Estudios Gage R&R', 'Ejercicio Análisis de Variación'],
    instructor: 'Carlos Zamora',
  },
  {
    slug: 'estudios-de-concordancia',
    cat: 'six',
    nombre: 'Estudios de Concordancia',
    titulo: 'Estudios de Concordancia',
    subtitulo: 'Cuando el criterio es humano y no un instrumento',
    duracion: '1 h 1 min',
    minutos: 61,
    descripcion: 'Descubre qué son los Estudios de Concordancia y cómo aplicarlos en la mejora continua y la investigación científica. Este curso te enseña a evaluar el grado de acuerdo y correlación entre diferentes mediciónes, interpretando resultados con métodos estadísticos confiables.',
    paraQuien: 'Profesionales de Control de Calidad, Ingenieros de Procesos, Auditores Internos, Supervisores de Producción, Analistas de Datos y cualquier especialista que trabaje con sistemas de medición.',
    // El sitio publica la duración y el número de capítulos, pero no sus
    // nombres. No se inventan.
    temas: [],
    temasIncompletos: true,
    capitulos: 5,
    formatos: ['Ejercicio Análisis de Concordancia', 'Ejercicio Valor Kappa', 'Ejercicio de Estudios de Concordancia'],
    instructor: 'Carlos Zamora',
  },
  {
    slug: 'analisis-de-datos-continuos',
    cat: 'six',
    nombre: 'Análisis de Datos Continuos',
    titulo: 'Análisis de Datos Continuos',
    subtitulo: 'Qué dicen los datos que sí se miden',
    duracion: '2 h 2 min',
    minutos: 122,
    descripcion: 'Domina las herramientas esenciales para analizar datos continuos y resolver problemas de causa raíz en tus procesos. Este curso combina teoría y práctica con herramientas gráficas como boxplot, scatterplot y análisis de capacidad.',
    paraQuien: 'Supervisores, Gerentes de Producción, Ingenieros de Procesos, Líderes de Mejora Continua y Profesionales encargados de optimizar operaciones y reducir desperdicios.',
    temas: [
      ['Introducción a Datos Continuos y Boxplot', 1],
      ['Análisis de Datos Continuos en Minitab', 1],
      ['Scatterplots y Coeficiente de Correlación', 1],
      ['Análisis de Correlación con Pearson', 1],
      ['Análisis Multivariado y Distribución Normal', 1],
      ['Capability Analysis y Gráficas Multivariadas', 1],
      ['Variables Continuas y Discretas', 1],
      ['Ejercicios Avanzados', 1],
    ],
    formatos: ['Ejercicio Gráfico de Series de Tiempo', 'Ejercicio Análisis de Regresión'],
    instructor: 'Carlos Zamora',
  },
  {
    slug: 'pruebas-de-hipotesis',
    cat: 'six',
    nombre: 'Pruebas de Hipótesis',
    titulo: 'Pruebas de Hipótesis',
    subtitulo: 'Probar la diferencia en vez de suponerla',
    duracion: '1 h 54 min',
    minutos: 114,
    descripcion: 'Domina las pruebas de hipótesis estadísticas y eleva tus habilidades de análisis al siguiente nivel: del F-Test y el t-Test a los errores alfa y beta, el p-value y su aplicación en Minitab.',
    paraQuien: 'Analistas de Datos, Profesionales de Calidad, Ingenieros de Procesos e Investigadores.',
    temas: [
      ['Fundamentos de Pruebas de Hipótesis', 1],
      ['F-Test, t-Test y Ji Cuadrado', 1],
      ['Errores Alfa, Beta y P Value', 1],
      ['Ejemplos de Hipótesis Nula y Alterna', 1],
      ['F-Test y Boxplot en Minitab', 1],
      ['Probability Plot y Varianzas Iguales', 1],
      ['Hipótesis Alterna y F-Test', 1],
      ['t-Test y Cálculo de Media en Minitab', 1],
      ['Two-sample t-Test y Run Outs', 1],
    ],
    formatos: ['Ejercicio Pruebas de Hipótesis', 'Ejercicio P-Value', 'Ejercicio F-Test'],
    instructor: 'Carlos Zamora',
  },
  {
    slug: 'anova',
    cat: 'six',
    nombre: 'ANOVA',
    titulo: 'ANOVA · Análisis de la Varianza',
    subtitulo: 'Comparar más de dos escenarios a la vez',
    duracion: '2 h 8 min',
    minutos: 128,
    descripcion: 'Domina el análisis de la varianza (ANOVA) y aprende a evaluar la variabilidad en tus procesos con un enfoqué estadístico confiable.',
    paraQuien: 'Aspirantes a Six Sigma Green Belt, Ingenieros de Calidad, Analistas de Datos y Líderes de Mejora Continua.',
    temas: [
      ['Introducción a ANOVA', 1],
      ['Requisitos de ANOVA y Gage R&R', 1],
      ['Igualdad de Varianzas', 1],
      ['Contribution, F-Value y R-Squared', 1],
      ['Modelos y Análisis Multifactorial', 1],
      ['Main Effect Plot', 1],
      ['Gráfico Multivariado e Interacción de Factores', 1],
      ['Modelos Generales y ANOVA Avanzado', 1],
      ['Ejercicios de Interpretación con R-Squared', 1],
      ['Caso Práctico: ANOVA en la Industria del Vino', 1],
    ],
    formatos: ['Ejercicio ANOVA', 'Ejercicio TuKey'],
    instructor: 'Carlos Zamora',
  },
  {
    slug: 'regresiones',
    cat: 'six',
    nombre: 'Regresiones',
    alias: ['Regresiones (Simples y Múltiples)'],
    titulo: 'Regresiónes Lineales Simples y Múltiples',
    subtitulo: 'Modelar la relacion entre variables',
    duracion: '1 h 31 min',
    minutos: 91,
    descripcion: 'Domina el análisis predictivo con regresiones lineales simples y múltiples, una de las herramientas estadísticas más utilizadas en Six Sigma. Aprenderás desde los fundamentos hasta aplicaciónes prácticas de regresiones no lineales, correlaciónes y ejemplos reales en Excel y Minitab.',
    paraQuien: 'Analistas de Datos, Ingenieros de Procesos, Supervisores de Operaciones, Líderes de Mejora Continua y Profesionales de Calidad que buscan realizar análisis predictivo.',
    temas: [
      ['Introducción a las Regresiónes Lineales', 1],
      ['Ejercicio práctico de Regresión Lineal Simple', 1],
      ['Aplicación de la Regresión Simple en Minitab', 1],
      ['Regresión Múltiple y No Lineal', 1],
      ['Ejercicio de Regresión Múltiple', 2],
      ['Ejercicio avanzado con Matrix Plot', 1],
    ],
    formatos: ['Ejercicio de Regresión Lineal', 'Ejercicio de Coeficiente de Determinacion', 'Ejercicio de Regresión Múltiple'],
    instructor: 'Carlos Zamora',
  },
  {
    slug: 'control-estadistico-de-procesos',
    cat: 'six',
    nombre: 'Control Estadístico de Procesos',
    alias: ['Control Estadístico de Proceso'],
    titulo: 'Control Estadístico de Procesos',
    subtitulo: 'Sostener la mejora en el tiempo',
    duracion: '57 min',
    minutos: 57,
    descripcion: 'Descubre cómo aplicar el Control Estadístico de Procesos (CEP) para garantizar la calidad y estabilidad en tus operaciones, distinguiendo la causa común de la asignable y llevándolo a las gráficas de control.',
    paraQuien: 'Aspirantes a Six Sigma Green Belt, Supervisores de Producción, Ingenieros de Calidad, Líderes de Mejora Continua y profesionales interesados en el control estadístico de procesos.',
    temas: [
      ['Introducción al CEP', 1],
      ['Variación: causa común contra causa asignable', 1],
      ['Gráficas de Control X-R y X-S: fundamentos', 2],
      ['Implementación de Gráficas X-S en Minitab', 1],
    ],
    // El plan de estudios declara 6 capítulos; el sitio solo publica el nombre
    // de cinco.
    temasIncompletos: true,
    capitulos: 6,
    formatos: ['Ejercicio Gráfica de Control', 'Ejercicio Análisis de Causa Raíz'],
    instructor: 'Carlos Zamora',
  },
// ---- Validación de Procesos y herramientas -----------------------------
  // -------------------------------------------------------------------------
  // INGENIERÍA DE CALIDAD
  //
  // Aquí vive TODA la validación. El sitio actual la parte en dos rutas
  // —/cursos-de-ingenieria-de-calidad/ y /cursos-de-process-validation/— pero
  // publica TMV y Protocolos y Reportes de Validación bajo Ingeniería de
  // Calidad: la propia fuente contradice la separación. Validación de Procesos
  // es la CERTIFICACIÓN que sale de esta categoría, no una categoría hermana.
  //
  // De los 5 cursos de /cursos-de-process-validation/ solo uno tiene datos
  // publicables; los otros cuatro están vacíos o devuelven otro curso (ver
  // CONTEXTO.md §7). No se inventan: se quedan sin enlace en la certificación.
  //
  // FORMATOS: siete de estos cursos declaran "SW Layout / HOE / Takt Time
  // Calculator" —plantillas de Lean Manufacturing en cursos de documentación
  // regulada y lectura de planos—. Es el mismo copiar-pegar que ya se detectó
  // en el catálogo, pero aquí el error es evidente, así que NO se transcribe:
  // se publica la lista vacía hasta que Julio confirme cuáles son las buenas.
  //
  // Julio ya confirmó dos: el de TMV es "Protocolo del método de medición" y el
  // de pFMEA es "Documento pFMEA". Los demás siguen en blanco.
  // -------------------------------------------------------------------------
  {
    slug: 'introduccion-ingenieria-de-calidad',
    cat: 'cal',
    nombre: 'Introducción a la Ingeniería de Calidad',
    alias: ['Introducción a la Ingeniería de Calidad y Empresas de Dispositivos Médicos'],
    titulo: 'Introducción a la Ingeniería de Calidad',
    subtitulo: 'El rol, sus retos y dónde se decide',
    duracion: '17 min',
    minutos: 17,
    descripcion: 'La puerta de entrada al oficio: qué hace un ingeniero de calidad, qué conocimientos exige el puesto, en qué se especializa y cómo toma decisiones basadas en riesgo cuando el problema aparece en plena manufactura.',
    paraQuien: 'Líderes organizacionales, directivos del área de ingeniería, profesionistas responsables de dirigir equipos de alto desempeño y todo aquel interesado en el tema.',
    temas: [
      ['Rol del Ingeniero de Calidad', 1],
      ['Retos y Soluciones del Ingeniero de Calidad', 1],
    ],
    formatos: [],
    instructor: 'Johan Rojas',
  },
  {
    slug: 'buenas-practicas-de-manufactura',
    cat: 'cal',
    nombre: 'Buenas Prácticas de Manufactura',
    alias: ['BPM'],
    titulo: 'Buenas Prácticas de Manufactura',
    subtitulo: 'Cómo se trabaja dentro de un área controlada',
    duracion: '28 min',
    minutos: 28,
    descripcion: 'Garantiza la calidad y el cumplimiento de los estándares en tus procesos con este curso de Buenas Prácticas de Manufactura (BPM). Aprende los fundamentos, prácticas clave y estrategias de mejora para optimizar la operación en áreas controladas, asegurando un entorno seguro y eficiente.',
    paraQuien: 'Supervisores de Producción, Ingenieros de Calidad, Líderes de Mejora Continua, Operadores de Manufactura y cualquier profesional involucrado en la gestión de procesos y áreas controladas.',
    temas: [
      ['Fundamentos de BPM y Prácticas de Higiene', 1],
      ['Comportamiento y Procedimientos en Áreas Controladas', 1],
    ],
    formatos: [],
    instructor: 'Johan Rojas',
  },
  {
    slug: 'buenas-practicas-de-documentacion',
    cat: 'cal',
    nombre: 'Buenas Prácticas de Documentación',
    alias: ['BPD'],
    titulo: 'Buenas Prácticas de Documentación',
    subtitulo: 'El registro que sostiene la trazabilidad',
    duracion: '26 min',
    minutos: 26,
    descripcion: 'Domina las Buenas Prácticas de Documentación (BPD) para garantizar la trazabilidad, el cumplimiento normativo y la calidad en los procesos de tu organización. Este curso te preparará para implementar procedimientos efectivos, realizar correcciones documentales y asegurar registros impecables en la industria regulada.',
    paraQuien: 'Ingenieros de Calidad, Auditores, Supervisores de Producción, Especialistas en Documentación y cualquier profesional responsable de mantener la trazabilidad y la precisión en registros documentales.',
    temas: [
      ['Importancia de la Documentación y Trazabilidad', 1],
      ['Correcciones Documentales y Auditorías', 1],
    ],
    formatos: [],
    instructor: 'Johan Rojas',
  },
  {
    slug: 'lectura-de-planos',
    cat: 'cal',
    nombre: 'Lectura de Planos',
    titulo: 'Lectura de Planos',
    subtitulo: 'Leer la tolerancia antes de medirla',
    duracion: '30 min',
    minutos: 30,
    descripcion: 'Domina la lectura e interpretación de planos para garantizar la calidad y precisión en los procesos de manufactura. Este curso te enseñará a identificar puntos críticos, comprender tolerancias y dimensiones clave, y gestionar notas y especificaciones del cliente para asegurar el cumplimiento de los estándares.',
    paraQuien: 'Ingenieros de Calidad, Técnicos de Producción, Inspectores de Calidad, Diseñadores Industriales y cualquier profesional que trabaje con planos en el ámbito de manufactura o ingeniería.',
    temas: [
      ['Fundamentos de Lectura de Planos', 1],
      ['Simbología, Tolerancias y Rangos de Aceptación', 1],
      ['Planes de Muestreo y Gestión de Especificaciones', 1],
    ],
    formatos: [],
    instructor: 'Johan Rojas',
  },
  {
    slug: 'cuartos-limpios',
    cat: 'cal',
    nombre: 'Cuartos Limpios',
    titulo: 'Cuartos Limpios',
    subtitulo: 'Clasificar, validar y monitorear el ambiente',
    duracion: '35 min',
    minutos: 35,
    descripcion: 'Asegura el cumplimiento de estándares y la calidad en entornos controlados con este curso especializado en Cuartos Limpios. Aprende a clasificar, validar y controlar variables críticas para garantizar la seguridad y la precisión en tus procesos, cumpliendo con las regulaciones más exigentes.',
    paraQuien: 'Ingenieros de Calidad, Gerentes de Producción, Profesionales en la Industria Médica, Líderes de Validación y cualquier persona responsable de mantener y validar entornos controlados en la industria regulada.',
    temas: [
      ['Introducción', 1],
      ['Validación de Cuartos Limpios y Variables Críticas', 1],
      ['Protocolos de Validación y Control de Variables', 1],
      ['Post-Validación, Monitoreo y Revalidación', 1],
    ],
    formatos: [],
    instructor: 'Johan Rojas',
  },
  {
    slug: 'pfmea',
    cat: 'cal',
    nombre: 'Desarrollo de pFMEA',
    // "Riesgo Dentro del Proceso de Validación" es ESTE curso. Lo confirma el
    // plan de estudios de Validación de Procesos, que en ese módulo anota
    // "Módulo 9: Ingeniería de calidad" —el curso 9 de calidad es pFMEA— y le
    // asigna los mismos 38 minutos y los mismos 4 capítulos.
    alias: ['pFMEA', 'Desarrollo de pFMEA (PAMEF)', 'Riesgo Dentro del Proceso de Validación'],
    titulo: 'Desarrollo de pFMEA (PAMEF)',
    subtitulo: 'El riesgo, evaluado antes de que ocurra',
    duracion: '38 min',
    minutos: 38,
    descripcion: 'Identifica y gestiona riesgos en tus procesos con el desarrollo de pFMEA. Este curso te enseñará a estructurar y aplicar este análisis preventivo, evaluando modos de falla, su criticidad y las medidas necesarias para mitigar riesgos, asegurando la calidad y confiabilidad en tus operaciones.',
    paraQuien: 'Ingenieros de Calidad, Líderes de Mejora Continua, Supervisores de Producción, Gerentes de Proyectos y cualquier profesional responsable de la identificación y mitigación de riesgos en procesos industriales.',
    temas: [
      ['Introducción al pFMEA y su Enfoque Preventivo', 1],
      ['Identificación de Modos de Falla', 1],
      ['Estructura del pFMEA: Formato y Roles Clave', 1],
      ['Aplicación Práctica y Actualización del pFMEA', 1],
    ],
    formatos: ['Documento pFMEA'],
    instructor: 'Johan Rojas',
  },
  {
    slug: 'planes-de-control',
    cat: 'cal',
    nombre: 'Desarrollo de Planes de Control',
    alias: ['Planes de Control', 'Control Plan'],
    titulo: 'Desarrollo de Planes de Control',
    subtitulo: 'Qué se mide, cuándo y qué se hace si se sale',
    duracion: '20 min',
    minutos: 20,
    descripcion: 'Aprende a estructurar planes de control efectivos para garantizar la calidad y consistencia en tus procesos de manufactura. Este curso te guiará desde los conceptos básicos hasta la documentación y ejecución de planes que aborden puntos críticos, tolerancias y mediciones esenciales para tus operaciones.',
    paraQuien: 'Ingenieros de Calidad, Supervisores de Producción, Líderes de Mejora Continua, Auditores y cualquier profesional que busque implementar o mejorar planes de control en procesos industriales.',
    temas: [
      ['Conceptos Fundamentales', 1],
      ['Ejecución, Actualización y Manejo de Desviaciones', 1],
    ],
    formatos: [],
    instructor: 'Johan Rojas',
  },
  {
    slug: 'analisis-de-causa-raiz',
    cat: 'cal',
    nombre: 'Análisis de Causa Raíz',
    alias: ['Análisis de Causa Raíz en Calidad'],
    titulo: 'Análisis de Causa Raíz en Calidad',
    subtitulo: 'Del hallazgo al CAPA que cierra',
    duracion: '34 min',
    minutos: 34,
    descripcion: 'Domina las bases del Análisis de Causa Raíz para detectar, prevenir y resolver fallos en tus procesos. Este curso te guiará en el uso de herramientas de calidad, estrategias Lean y enfoques preventivos, asegurando que tus operaciones mantengan los más altos estándares de eficiencia y confiabilidad.',
    paraQuien: 'Ingenieros de Calidad, Supervisores de Producción, Líderes de Mejora Continua, Auditores de Procesos y cualquier profesional enfocado en la solución de problemas y optimización de procesos.',
    temas: [
      ['Importancia del Análisis de Causa Raíz', 1],
      ['Tipos de No Conformidad', 1],
      ['CAPA: Control Documental y Estrategias Correctivas', 1],
      ['Herramientas Lean y Puntos Críticos para la Mejora Continua', 1],
    ],
    formatos: [],
    instructor: 'Johan Rojas',
  },
  // ---- Los cinco cursos de validación ---------------------------------------
  // Vienen del plan de estudios de Johan (xlsx "Process Validation Opción 2"),
  // NO del sitio actual: sus páginas están vacías o devuelven otro curso. Donde
  // las dos fuentes se contradicen manda el plan de estudios, que es el que
  // cuadra con la duración de cada capítulo.
  {
    slug: 'lean-dentro-del-proceso-de-validacion',
    cat: 'cal',
    nombre: 'Lean Dentro del Proceso de Validación',
    titulo: 'Lean Dentro del Proceso de Validación',
    subtitulo: 'Validar sin cargarle desperdicio al proceso',
    duracion: '28 min',
    minutos: 28,
    descripcion: 'Un enfoque práctico para integrar el pensamiento Lean dentro del proceso de validación, con el objetivo de mejorar la eficiencia, reducir costos y asegurar la calidad en procesos automatizados y manuales. A través de herramientas como VSM, 5S, Kaizen, Poka-yokes y análisis Gemba, aprenderás a eliminar desperdicios, optimizar recursos y crear una cultura de mejora continua dentro de tu organización.',
    paraQuien: 'Ingenieros, supervisores, superintendentes, administradores, gerentes y directores involucrados en la validación de procesos, así como cualquier profesionista que desee optimizar sus procedimientos mediante el enfoque Lean.',
    temas: [
      ['Introducción al Pensamiento Lean en Validación', 1],
      ['Herramientas Lean para la Optimización de Procesos', 1],
      ['Estrategias para la Eficiencia y Calidad Continua', 1],
    ],
    formatos: [],
    instructor: 'Johan Rojas',
  },
  {
    slug: 'introduccion-validacion-ambiente-regulado',
    cat: 'cal',
    nombre: 'Introducción y Validación de Procesos en un Ambiente Regulado',
    titulo: 'Validación de Procesos en un Ambiente Regulado',
    subtitulo: 'Las reglas del juego en industria regulada',
    duracion: '19 min',
    minutos: 19,
    descripcion: 'Un enfoque práctico y estratégico sobre la validación de procesos en ambientes regulados, desde los fundamentos hasta la aplicación de normativas clave como FDA e ISO. A través de ejemplos y mejores prácticas aprenderás a garantizar la calidad, reducir errores y documentar adecuadamente tus validaciones, asegurando el cumplimiento con auditorías y regulaciones internacionales.',
    paraQuien: 'Ingenieros, supervisores, administradores, gerentes y directores en industrias reguladas como farmacéutica, dispositivos médicos, manufactura, alimentos y cualquier sector donde la validación de procesos sea un requisito esencial.',
    temas: [
      ['¿Por qué validar un proceso?', 1],
      ['Regulaciones clave en validaciones de procesos', 1],
    ],
    formatos: [],
    instructor: 'Johan Rojas',
  },
  {
    slug: 'pre-validaciones-de-procesos',
    cat: 'cal',
    nombre: 'Pre Validaciones de Procesos',
    titulo: 'Pre Validaciones de Procesos',
    subtitulo: 'Lo que se hace antes del protocolo',
    duracion: '33 min',
    minutos: 33,
    descripcion: 'Un enfoque estratégico sobre la prevalidación de procesos, con herramientas prácticas como lectura de planos, tolerancias, DOE y PFMEA para optimizar la ejecución de validaciones en entornos regulados. Aprenderás a identificar y minimizar riesgos, coordinar equipos y asegurar la efectividad de los procesos de validación desde la fase previa, mejorando la calidad y reduciendo costos operativos.',
    paraQuien: 'Ingenieros, supervisores, técnicos de calidad, especialistas en manufactura, gerentes y directores involucrados en la validación de procesos dentro de industrias reguladas como farmacéutica, dispositivos médicos, manufactura y alimentos.',
    temas: [
      ['Introducción a la Prevalidación', 1],
      ['Herramientas Clave en la Prevalidación', 1],
      ['Estrategias y Casos Prácticos', 1],
    ],
    formatos: [],
    instructor: 'Johan Rojas',
  },
  {
    slug: 'etapas-de-validaciones-de-procesos',
    cat: 'cal',
    nombre: 'Etapas de Validaciones de Procesos',
    titulo: 'Etapas de Validaciones de Procesos',
    subtitulo: 'IQ, OQ, PQ y validación de software',
    duracion: '1 h 40 min',
    minutos: 100,
    descripcion: 'Una guía detallada sobre IQ, OQ, PQ y validación de software que te permite desarrollar validaciones robustas, documentadas y en conformidad con regulaciones internacionales. Doce capítulos que recorren cada calificación de principio a fin: qué documentar, cómo ejecutar el protocolo y cómo cerrar con evidencia objetiva.',
    paraQuien: 'Ingenieros, supervisores, técnicos de validación, gerentes de calidad, especialistas en cumplimiento regulatorio y cualquier profesional involucrado en la calificación y validación de procesos dentro de industrias como farmacéutica, dispositivos médicos, manufactura y software regulado.',
    temas: [
      ['IQ: Introducción y Conceptos Básicos del IQ', 1],
      ['IQ: Documentación y Requerimientos para el IQ', 1],
      ['IQ: Ejecución y Reporte del IQ', 1],
      ['Introducción a la Cualificación Operativa (OQ)', 1],
      ['Identificación y Análisis de Variables Críticas', 1],
      ['Ejecución de Pruebas y Documentación de Resultados', 1],
      ['PQ: Introducción a la Validación de Performance Qualification', 1],
      ['PQ: Preparación y Ejecución del Protocolo PQ', 1],
      ['PQ: Órdenes de Manufactura, Inspección y Reporte Final', 1],
      ['Validación de Software: Introducción', 1],
      ['Validación de Software: Elementos Clave y Procedimiento', 1],
      ['Validación de Software: Retos Funcionales y Revisión Final', 1],
    ],
    formatos: [],
    instructor: 'Johan Rojas',
  },
  {
    slug: 'manteniendo-el-estado-de-validacion',
    cat: 'cal',
    nombre: 'Manteniendo el Estado de Validación',
    alias: ['Manteniendo el Estado de la Validación'],
    titulo: 'Manteniendo el Estado de Validación',
    subtitulo: 'Que no se caiga con el primer cambio',
    duracion: '1 h 29 min',
    minutos: 89,
    descripcion: 'Validar un proceso no es suficiente: hay que mantener el estado validado a lo largo del tiempo. Un enfoque práctico sobre control documental, auditorías internas, gestión de cambios y mantenimiento de equipos validados, para cumplir con ISO 9001 e ISO 13485 sin comprometer la calidad ni el cumplimiento normativo.',
    paraQuien: 'Ingenieros, supervisores, técnicos de calidad, gerentes de validación, profesionales de cumplimiento regulatorio y cualquier especialista involucrado en la gestión de procesos validados en industrias reguladas.',
    temas: [
      ['Introducción al Control de Procesos', 1],
      ['Métodos y Estrategias de Control', 1],
      ['Controles Funcionales y su Impacto Estratégico', 1],
      ['Conceptos Básicos del Ciclo de Vida de Validaciones', 1],
      ['Documentación y Gestión de Equipos en el Ciclo de Validación', 1],
      ['Manejo de Cambios y Mantenimiento del Estado Validado', 1],
      ['Importancia de la Documentación en Validaciones', 1],
      ['Procedimientos y Estándares para Documentación', 1],
      ['Responsabilidades y Aplicaciones en la Documentación', 1],
    ],
    formatos: [],
    instructor: 'Johan Rojas',
  },
  {
    slug: 'protocolos-y-reportes-de-validacion',
    cat: 'cal',
    nombre: 'Protocolos y Reportes de Validación',
    // OJO: su temario (IQ, OQ, PQ y plan maestro) es casi el mismo que el del
    // módulo "Etapas de Validaciones de Procesos" de la certificación, cuya
    // página está rota. NO se le pone alias: equipararlos sería una suposición
    // nuestra. Pendiente de que Julio confirme si son el mismo curso.
    titulo: 'Protocolos y Reportes de Validación',
    subtitulo: 'Del protocolo al plan maestro de validación',
    duracion: '53 min',
    minutos: 53,
    descripcion: 'Domina el desarrollo y documentación de protocolos de validación IQ, OQ y PQ con este curso práctico. Aprenderás a identificar puntos críticos, estructurar planes maestros y documentar pruebas clave para cumplir con los estándares de calidad y las regulaciones más exigentes en la industria.',
    paraQuien: 'Ingenieros de Validación, Profesionales de Calidad, Supervisores de Producción, Auditores de Procesos y cualquier persona involucrada en la creación y gestión de protocolos de validación en industrias reguladas.',
    temas: [
      ['Introducción a Protocolos IQ, OQ y PQ', 1],
      ['Estrategias para el Desarrollo de Protocolos', 1],
      ['Plan Maestro de Validación', 1],
      ['Preparación de la Fase PQ', 1],
      ['Inspección y Revisión de Puntos Críticos en PQ', 1],
      ['Cierre del Plan Maestro y Validación Continua', 1],
    ],
    formatos: [],
    instructor: 'Johan Rojas',
  },
  {
    slug: 'tmv',
    cat: 'cal',
    nombre: 'Test Method Validation (TMV)',
    alias: ['Validación del Método de Medición (TMV)'],
    titulo: 'Validación del Método de Medición (TMV)',
    subtitulo: 'Validar el método con el que mides',
    duracion: '41 min',
    minutos: 41,
    descripcion: 'Asegura la precisión y confiabilidad en los procesos de medición. Aprenderas a validar métodos por variables y atributos, desarrollar protocolos efectivos y utilizar herramientas como Minitab para garantizar que tu sistema de medición cumpla con los estándares más exigentes.',
    paraQuien: 'Ingenieros de Validación, Profesionales de Calidad, Supervisores de Producción, Auditores de Procesos y cualquier persona involucrada en la validación de métodos y equipos de medición en industrias reguladas.',
    temas: [
      ['Introducción y Puntos Críticos en Medición', 1],
      ['Validación por Atributos: Criterios y Estrategias', 1],
      ['Análisis Atributivo con Minitab', 1],
      ['Validación por Variables: Documentación y Criterios', 1],
      ['Desarrollo de Protocolos y Reportes Finales', 1],
    ],
    formatos: ['Protocolo del método de medición'],
    instructor: 'Johan Rojas',
  },
  {
    slug: 'minitab',
    cat: 'six',
    nombre: 'Minitab',
    alias: ['Herramientas Estadísticas en Validaciones (Minitab)'],
    titulo: 'Curso Minitab',
    subtitulo: 'La herramienta con la que se sustenta',
    duracion: '3 h 50 min',
    minutos: 230,
    descripcion: 'Conviértete en un experto en análisis de datos y toma decisiones basadas en evidencia. Aprende a utilizar Minitab para interpretar datos, optimizar procesos y resolver problemas con precisión estadística.',
    paraQuien: 'Profesionales de Calidad, Producción, Mejora Continua, Ingeniería y Análisis de Datos que buscan optimizar procesos mediante herramientas estadísticas.',
    // El sitio declara 15 capítulos pero solo publica el nombre de ocho.
    temas: [
      ['Introducción a Minitab', 1],
      ['Análisis Gráficos', 1],
      ['Herramientas Estadísticas', 1],
      ['T-Student', 1],
      ['Proporciones y Anova', 1],
      ['ANOVAS', 1],
      ['Gráficos de Control', 1],
      ['Diseño de Experimentos', 1],
    ],
    temasIncompletos: true,
    capitulos: 15,
    formatos: ['Ejercicios de Estadística Descriptiva', 'Ejercicios de MSA', 'Ejercicios de ANOVA'],
    instructor: 'Luis Rochín',
  },
];

export const porCategoria = (cat) => CURSOS.filter((c) => c.cat === cat);
export const cursoPorSlug = (slug) => CURSOS.find((c) => c.slug === slug);

/** Busca un curso por el nombre con el que lo cite una certificacion. */
export const cursoPorNombre = (n) => CURSOS.find((c) => c.nombre === n || c.alias?.includes(n));

/** Capítulos de un curso: los declarados, o la suma de las partes de sus temas. */
export const capitulosDe = (c) => c.capitulos || c.temas.reduce((n, [, p]) => n + p, 0);

/** Totales de una categoría, calculados —nunca escritos a mano. */
export function totalesDe(cat) {
  const cs = porCategoria(cat);
  const min = cs.reduce((n, c) => n + c.minutos, 0);
  return {
    cursos: cs.length,
    capitulos: cs.reduce((n, c) => n + capitulosDe(c), 0),
    minutos: min,
    horas: `${Math.floor(min / 60)} h${min % 60 ? ` ${min % 60} min` : ''}`,
  };
}
